module.exports = __webpack_public_path__ + "img/Map.28cc9183.png";